module.exports = __webpack_public_path__ + "assets/108fa3162793fa9a8ad5dafef5c1e4b1.png";